import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookS3 } from './taf-book-s3-list';


import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookS3Service {

    //need to have this somewhere besides hardcoded in here

    //private _tafBookS3Url = ` http://localhost:55706/api/systemmanagement/TAFBookS3`;
    private _tafBookS3Url = `api/systemmanagement/TAFBookS3`;
    
    constructor(private httpHelper: HttpHelper) { }

    getTAFBookS3(): Observable<ITAFBookS3> {
         return this.httpHelper.get(`${this._tafBookS3Url}`)
             //.map((response: Response) => <ITAFBookS3> response.json())
             //.do(data => console.log('ITafBookS3: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-s3/taf-book-s3.service.ts
 **/